import { FunctionComponent, useEffect, useState } from 'react';

import { InputComponent } from '../../../components/InputComponent';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';
import { PopUpComponent } from '../../../components/PopUpComponent';
import { ActivePopUp } from '../../../interfaces/interfaceInventory';

interface IWhiteListSamProps {
  serviceInventory: IInventoryProvider;
}

export const ModifyWhiteListSam = (props: IWhiteListSamProps) => {
  const { serviceInventory } = props;

  const bodyContent = () => {
    return (
      <div className="w-full h-full flex p-6 justify-center">
        <InputComponent
          type="text"
          name="Comentarios"
          placeholder="Observaciones"
          label="Observaciones"
          value={serviceInventory.whiteListValue}
          onChange={serviceInventory.handleOnChangeBodyWhiteList}
        />
      </div>
    );
  };

  return (
    <PopUpComponent
      header={
        serviceInventory.samInfo?.WhiteList === true
          ? 'Quitar de la lista blanca'
          : 'Agregar a la lista blanca'
      }
      showPopUp={
        serviceInventory.activePopUp === ActivePopUp.ModifyWhiteList &&
        serviceInventory.showPopUp
      }
      onSubmit={() => serviceInventory.onModifyWhiteList()}
      onClosePopUp={() => serviceInventory.closePopUp()}
      footer={true}
      body={bodyContent()}
    />
  );
};
